export const PAYMENT_URL = process.env.REACT_APP_DEVEL === 'true'
  ? "https://encoln-payment-dev.web.app/"
  : "https://payment.encolnschool.com/";
